const url = typeof window !== 'undefined' ? window?.location?.href : '';
const urlOmsId = url.match(/[0-9]{9}/g);
const anchorSku = url.match(/\?omsid=([0-9]+)\&?/i);
const omsId = anchorSku ? anchorSku[1] : urlOmsId ? urlOmsId[0] : null;
export default omsId ; 
